import { render, staticRenderFns } from "./topic_list.vue?vue&type=template&id=6232f75d&scoped=true&"
import script from "./topic_list.vue?vue&type=script&lang=js&"
export * from "./topic_list.vue?vue&type=script&lang=js&"
import style0 from "./topic_list.vue?vue&type=style&index=0&id=6232f75d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232f75d",
  null
  
)

export default component.exports